import { render } from "./ProjectIndexPage.vue?vue&type=template&id=3f672966"
import script from "./ProjectIndexPage.vue?vue&type=script&lang=js"
export * from "./ProjectIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__